/*
  Personal/local dev servers are served from *.flocknote.uno (or localhost) and
  are in constant flux while we build features, so their errors would flood
  Sentry. They'd also be mislabeled: getSentryEnvironment() maps unrecognized
  hostnames to "production". Keep Sentry off for them entirely.

  Shared servers (flocknote.com, and the *.internal dev/staging/qa boxes) still
  report — each to its own environment.
*/
export const isSentryEnabled = (
  hostname = (window && window.location && window.location.hostname) || ""
) => {
  return !(
    hostname.endsWith(".flocknote.uno") ||
    hostname === "localhost" ||
    hostname === "127.0.0.1"
  );
};
